import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-queue-confirmation" }
const _hoisted_2 = { class: "message-queue-confirmation-tip" }
const _hoisted_3 = {
  key: 0,
  class: "message-queue-confirmation-tip-number"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formattedTips, (part, index) => {
        return (_openBlock(), _createElementBlock("span", { key: index }, [
          (part.isNumber)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(part.content), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(part.content), 1))
        ]))
      }), 128))
    ]),
    (!$setup.props.payload.status && !$setup.isConfirmed)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "message-queue-confirmation-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.sendMessage && $setup.sendMessage(...args)))
        }, _toDisplayString($setup.TUITranslateService.t('AIDesk.确认转人工')), 1))
      : _createCommentVNode("", true)
  ]))
}